export const EWC_CODES = [
  { ewcCode: '010101', description: 'Metals' },
  { ewcCode: '010102', description: 'Average construction' },
  { ewcCode: '010304', description: 'Average construction' },
  { ewcCode: '010305', description: 'Average construction' },
  { ewcCode: '010306', description: 'Average construction' },
  { ewcCode: '010307', description: 'Metals' },
  { ewcCode: '010308', description: 'Average construction' },
  { ewcCode: '010309', description: 'Metals' },
  { ewcCode: '010399', description: 'Average construction' },
  { ewcCode: '010407', description: 'Average construction' },
  { ewcCode: '010408', description: 'Aggregates' },
  { ewcCode: '010409', description: 'Soils' },
  { ewcCode: '010410', description: 'Average construction' },
  { ewcCode: '010411', description: 'Average construction' },
  { ewcCode: '010412', description: 'Average construction' },
  { ewcCode: '010413', description: 'Average construction' },
  { ewcCode: '010499', description: 'Average construction' },
  { ewcCode: '010504', description: 'Soils' },
  { ewcCode: '010505', description: 'Soils' },
  { ewcCode: '010506', description: 'Soils' },
  { ewcCode: '010507', description: 'Soils' },
  { ewcCode: '010508', description: 'Soils' },
  { ewcCode: '010599', description: 'Average construction' },
  { ewcCode: '020101', description: 'Average construction' },
  { ewcCode: '020102', description: 'Average construction' },
  { ewcCode: '020103', description: 'Average construction' },
  { ewcCode: '020104', description: 'Plastics: average plastics' },
  { ewcCode: '020106', description: 'Average construction' },
  { ewcCode: '020107', description: 'Wood' },
  { ewcCode: '020108', description: 'Average construction' },
  { ewcCode: '020109', description: 'Average construction' },
  { ewcCode: '020110', description: 'Metals' },
  { ewcCode: '020199', description: 'Average construction' },
  { ewcCode: '020201', description: 'Average construction' },
  { ewcCode: '020202', description: 'Average construction' },
  { ewcCode: '020203', description: 'Average construction' },
  { ewcCode: '020204', description: 'Average construction' },
  { ewcCode: '020299', description: 'Average construction' },
  { ewcCode: '020301', description: 'Average construction' },
  { ewcCode: '020302', description: 'Average construction' },
  { ewcCode: '020303', description: 'Average construction' },
  { ewcCode: '020304', description: 'Average construction' },
  { ewcCode: '020305', description: 'Average construction' },
  { ewcCode: '020399', description: 'Average construction' },
  { ewcCode: '020401', description: 'Soils' },
  { ewcCode: '020402', description: 'Average construction' },
  { ewcCode: '020403', description: 'Average construction' },
  { ewcCode: '020499', description: 'Average construction' },
  { ewcCode: '020501', description: 'Average construction' },
  { ewcCode: '020502', description: 'Average construction' },
  { ewcCode: '020599', description: 'Average construction' },
  { ewcCode: '020601', description: 'Average construction' },
  { ewcCode: '020602', description: 'Average construction' },
  { ewcCode: '020603', description: 'Average construction' },
  { ewcCode: '020699', description: 'Average construction' },
  { ewcCode: '020701', description: 'Average construction' },
  { ewcCode: '020702', description: 'Average construction' },
  { ewcCode: '020703', description: 'Average construction' },
  { ewcCode: '020704', description: 'Average construction' },
  { ewcCode: '020705', description: 'Average construction' },
  { ewcCode: '020799', description: 'Average construction' },
  { ewcCode: '030101', description: 'Wood' },
  { ewcCode: '030104', description: 'Wood' },
  { ewcCode: '030105', description: 'Wood' },
  { ewcCode: '030199', description: 'Average construction' },
  { ewcCode: '030201', description: 'Average construction' },
  { ewcCode: '030202', description: 'Wood' },
  { ewcCode: '030203', description: 'Wood' },
  { ewcCode: '030204', description: 'Average construction' },
  { ewcCode: '030205', description: 'Wood' },
  { ewcCode: '030299', description: 'Wood' },
  { ewcCode: '030301', description: 'Wood' },
  { ewcCode: '030302', description: 'Average construction' },
  { ewcCode: '030305', description: 'Paper and board: paper' },
  { ewcCode: '030307', description: 'Paper and board: mixed' },
  { ewcCode: '030308', description: 'Paper and board: mixed' },
  { ewcCode: '030309', description: 'Average construction' },
  { ewcCode: '030310', description: 'Average construction' },
  { ewcCode: '030311', description: 'Average construction' },
  { ewcCode: '030399', description: 'Average construction' },
  { ewcCode: '040101', description: 'Average construction' },
  { ewcCode: '040102', description: 'Average construction' },
  { ewcCode: '040103', description: 'Average construction' },
  { ewcCode: '040104', description: 'Average construction' },
  { ewcCode: '040105', description: 'Average construction' },
  { ewcCode: '040106', description: 'Average construction' },
  { ewcCode: '040107', description: 'Average construction' },
  { ewcCode: '040108', description: 'Average construction' },
  { ewcCode: '040109', description: 'Average construction' },
  { ewcCode: '040199', description: 'Average construction' },
  { ewcCode: '040209', description: 'Average construction' },
  { ewcCode: '040210', description: 'Average construction' },
  { ewcCode: '040214', description: 'Average construction' },
  { ewcCode: '040215', description: 'Average construction' },
  { ewcCode: '040216', description: 'Average construction' },
  { ewcCode: '040217', description: 'Average construction' },
  { ewcCode: '040219', description: 'Average construction' },
  { ewcCode: '040220', description: 'Average construction' },
  { ewcCode: '040221', description: 'Average construction' },
  { ewcCode: '040222', description: 'Average construction' },
  { ewcCode: '040299', description: 'Average construction' },
  { ewcCode: '050102', description: 'Average construction' },
  { ewcCode: '050103', description: 'Average construction' },
  { ewcCode: '050104', description: 'Average construction' },
  { ewcCode: '050105', description: 'Average construction' },
  { ewcCode: '050106', description: 'Average construction' },
  { ewcCode: '050107', description: 'Average construction' },
  { ewcCode: '050108', description: 'Average construction' },
  { ewcCode: '050109', description: 'Average construction' },
  { ewcCode: '050110', description: 'Average construction' },
  { ewcCode: '050111', description: 'Average construction' },
  { ewcCode: '050112', description: 'Average construction' },
  { ewcCode: '050113', description: 'Average construction' },
  { ewcCode: '050114', description: 'Average construction' },
  { ewcCode: '050115', description: 'Average construction' },
  { ewcCode: '050116', description: 'Average construction' },
  { ewcCode: '050117', description: 'Average construction' },
  { ewcCode: '050199', description: 'Average construction' },
  { ewcCode: '050601', description: 'Average construction' },
  { ewcCode: '050603', description: 'Average construction' },
  { ewcCode: '050604', description: 'Average construction' },
  { ewcCode: '050699', description: 'Average construction' },
  { ewcCode: '050701', description: 'Average construction' },
  { ewcCode: '050702', description: 'Average construction' },
  { ewcCode: '050799', description: 'Average construction' },
  { ewcCode: '060101', description: 'Average construction' },
  { ewcCode: '060102', description: 'Average construction' },
  { ewcCode: '060103', description: 'Average construction' },
  { ewcCode: '060104', description: 'Average construction' },
  { ewcCode: '060105', description: 'Average construction' },
  { ewcCode: '060106', description: 'Average construction' },
  { ewcCode: '060199', description: 'Average construction' },
  { ewcCode: '060201', description: 'Average construction' },
  { ewcCode: '060203', description: 'Average construction' },
  { ewcCode: '060204', description: 'Average construction' },
  { ewcCode: '060205', description: 'Average construction' },
  { ewcCode: '060299', description: 'Average construction' },
  { ewcCode: '060311', description: 'Average construction' },
  { ewcCode: '060313', description: 'Metals' },
  { ewcCode: '060314', description: 'Average construction' },
  { ewcCode: '060315', description: 'Metals' },
  { ewcCode: '060316', description: 'Metals' },
  { ewcCode: '060399', description: 'Average construction' },
  { ewcCode: '060403', description: 'Average construction' },
  { ewcCode: '060404', description: 'Metals' },
  { ewcCode: '060405', description: 'Metals' },
  { ewcCode: '060499', description: 'Average construction' },
  { ewcCode: '060502', description: 'Average construction' },
  { ewcCode: '060503', description: 'Average construction' },
  { ewcCode: '060602', description: 'Average construction' },
  { ewcCode: '060603', description: 'Average construction' },
  { ewcCode: '060699', description: 'Average construction' },
  { ewcCode: '060701', description: 'Asbestos' },
  { ewcCode: '060702', description: 'Average construction' },
  { ewcCode: '060703', description: 'Metals' },
  { ewcCode: '060704', description: 'Average construction' },
  { ewcCode: '060799', description: 'Average construction' },
  { ewcCode: '060802', description: 'Average construction' },
  { ewcCode: '060899', description: 'Average construction' },
  { ewcCode: '060902', description: 'Average construction' },
  { ewcCode: '060903', description: 'Average construction' },
  { ewcCode: '060904', description: 'Average construction' },
  { ewcCode: '060999', description: 'Average construction' },
  { ewcCode: '061002', description: 'Average construction' },
  { ewcCode: '061099', description: 'Average construction' },
  { ewcCode: '061101', description: 'Average construction' },
  { ewcCode: '061199', description: 'Average construction' },
  { ewcCode: '061301', description: 'Wood' },
  { ewcCode: '061302', description: 'Average construction' },
  { ewcCode: '061303', description: 'Average construction' },
  { ewcCode: '061304', description: 'Asbestos' },
  { ewcCode: '061305', description: 'Average construction' },
  { ewcCode: '061399', description: 'Average construction' },
  { ewcCode: '070101', description: 'Average construction' },
  { ewcCode: '070103', description: 'Average construction' },
  { ewcCode: '070104', description: 'Average construction' },
  { ewcCode: '070107', description: 'Average construction' },
  { ewcCode: '070108', description: 'Average construction' },
  { ewcCode: '070109', description: 'Average construction' },
  { ewcCode: '070110', description: 'Average construction' },
  { ewcCode: '070111', description: 'Average construction' },
  { ewcCode: '070112', description: 'Average construction' },
  { ewcCode: '070199', description: 'Average construction' },
  { ewcCode: '070201', description: 'Average construction' },
  { ewcCode: '070203', description: 'Average construction' },
  { ewcCode: '070204', description: 'Average construction' },
  { ewcCode: '070207', description: 'Average construction' },
  { ewcCode: '070208', description: 'Average construction' },
  { ewcCode: '070209', description: 'Average construction' },
  { ewcCode: '070210', description: 'Average construction' },
  { ewcCode: '070211', description: 'Average construction' },
  { ewcCode: '070212', description: 'Average construction' },
  { ewcCode: '070213', description: 'Plastics: average plastics' },
  { ewcCode: '070214', description: 'Average construction' },
  { ewcCode: '070215', description: 'Average construction' },
  { ewcCode: '070216', description: 'Average construction' },
  { ewcCode: '070217', description: 'Average construction' },
  { ewcCode: '070299', description: 'Average construction' },
  { ewcCode: '070301', description: 'Average construction' },
  { ewcCode: '070303', description: 'Average construction' },
  { ewcCode: '070304', description: 'Average construction' },
  { ewcCode: '070307', description: 'Average construction' },
  { ewcCode: '070308', description: 'Average construction' },
  { ewcCode: '070309', description: 'Average construction' },
  { ewcCode: '070310', description: 'Average construction' },
  { ewcCode: '070311', description: 'Average construction' },
  { ewcCode: '070312', description: 'Average construction' },
  { ewcCode: '070399', description: 'Average construction' },
  { ewcCode: '070401', description: 'Average construction' },
  { ewcCode: '070403', description: 'Average construction' },
  { ewcCode: '070404', description: 'Average construction' },
  { ewcCode: '070407', description: 'Average construction' },
  { ewcCode: '070408', description: 'Average construction' },
  { ewcCode: '070409', description: 'Average construction' },
  { ewcCode: '070410', description: 'Average construction' },
  { ewcCode: '070411', description: 'Average construction' },
  { ewcCode: '070412', description: 'Average construction' },
  { ewcCode: '070413', description: 'Average construction' },
  { ewcCode: '070499', description: 'Average construction' },
  { ewcCode: '070501', description: 'Average construction' },
  { ewcCode: '070503', description: 'Average construction' },
  { ewcCode: '070504', description: 'Average construction' },
  { ewcCode: '070507', description: 'Average construction' },
  { ewcCode: '070508', description: 'Average construction' },
  { ewcCode: '070509', description: 'Average construction' },
  { ewcCode: '070510', description: 'Average construction' },
  { ewcCode: '070511', description: 'Average construction' },
  { ewcCode: '070512', description: 'Average construction' },
  { ewcCode: '070513', description: 'Average construction' },
  { ewcCode: '070514', description: 'Average construction' },
  { ewcCode: '070599', description: 'Average construction' },
  { ewcCode: '070601', description: 'Average construction' },
  { ewcCode: '070603', description: 'Average construction' },
  { ewcCode: '070604', description: 'Average construction' },
  { ewcCode: '070607', description: 'Average construction' },
  { ewcCode: '070608', description: 'Average construction' },
  { ewcCode: '070609', description: 'Average construction' },
  { ewcCode: '070610', description: 'Average construction' },
  { ewcCode: '070611', description: 'Average construction' },
  { ewcCode: '070612', description: 'Average construction' },
  { ewcCode: '070699', description: 'Average construction' },
  { ewcCode: '070701', description: 'Average construction' },
  { ewcCode: '070703', description: 'Average construction' },
  { ewcCode: '070704', description: 'Average construction' },
  { ewcCode: '070707', description: 'Average construction' },
  { ewcCode: '070708', description: 'Average construction' },
  { ewcCode: '070709', description: 'Average construction' },
  { ewcCode: '070710', description: 'Average construction' },
  { ewcCode: '070711', description: 'Average construction' },
  { ewcCode: '070712', description: 'Average construction' },
  { ewcCode: '070799', description: 'Average construction' },
  { ewcCode: '080111', description: 'Average construction' },
  { ewcCode: '080112', description: 'Average construction' },
  { ewcCode: '080113', description: 'Average construction' },
  { ewcCode: '080114', description: 'Average construction' },
  { ewcCode: '080115', description: 'Average construction' },
  { ewcCode: '080116', description: 'Average construction' },
  { ewcCode: '080117', description: 'Average construction' },
  { ewcCode: '080118', description: 'Average construction' },
  { ewcCode: '080119', description: 'Average construction' },
  { ewcCode: '080120', description: 'Average construction' },
  { ewcCode: '080121', description: 'Average construction' },
  { ewcCode: '080199', description: 'Average construction' },
  { ewcCode: '080201', description: 'Average construction' },
  { ewcCode: '080202', description: 'Average construction' },
  { ewcCode: '080203', description: 'Average construction' },
  { ewcCode: '080299', description: 'Average construction' },
  { ewcCode: '080307', description: 'Average construction' },
  { ewcCode: '080308', description: 'Average construction' },
  { ewcCode: '080312', description: 'Average construction' },
  { ewcCode: '080313', description: 'Average construction' },
  { ewcCode: '080314', description: 'Average construction' },
  { ewcCode: '080315', description: 'Average construction' },
  { ewcCode: '080316', description: 'Average construction' },
  { ewcCode: '080317', description: 'Average construction' },
  { ewcCode: '080318', description: 'Average construction' },
  { ewcCode: '080319', description: 'Average construction' },
  { ewcCode: '080399', description: 'Average construction' },
  { ewcCode: '080409', description: 'Average construction' },
  { ewcCode: '080410', description: 'Average construction' },
  { ewcCode: '080411', description: 'Average construction' },
  { ewcCode: '080412', description: 'Average construction' },
  { ewcCode: '080413', description: 'Average construction' },
  { ewcCode: '080414', description: 'Average construction' },
  { ewcCode: '080415', description: 'Average construction' },
  { ewcCode: '080416', description: 'Average construction' },
  { ewcCode: '080417', description: 'Average construction' },
  { ewcCode: '080499', description: 'Average construction' },
  { ewcCode: '080501', description: 'Average construction' },
  { ewcCode: '090101', description: 'Average construction' },
  { ewcCode: '090102', description: 'Average construction' },
  { ewcCode: '090103', description: 'Average construction' },
  { ewcCode: '090104', description: 'Average construction' },
  { ewcCode: '090105', description: 'Average construction' },
  { ewcCode: '090106', description: 'Metals' },
  { ewcCode: '090107', description: 'Paper and board: paper' },
  { ewcCode: '090108', description: 'Paper and board: paper' },
  { ewcCode: '090110', description: 'Average construction' },
  { ewcCode: '090111', description: 'Batteries' },
  { ewcCode: '090112', description: 'Average construction' },
  { ewcCode: '090113', description: 'Average construction' },
  { ewcCode: '090199', description: 'Average construction' },
  { ewcCode: '100101', description: 'Average construction' },
  { ewcCode: '100102', description: 'Average construction' },
  { ewcCode: '100103', description: 'Wood' },
  { ewcCode: '100104', description: 'Average construction' },
  { ewcCode: '100105', description: 'Average construction' },
  { ewcCode: '100107', description: 'Average construction' },
  { ewcCode: '100109', description: 'Average construction' },
  { ewcCode: '100113', description: 'Average construction' },
  { ewcCode: '100114', description: 'Average construction' },
  { ewcCode: '100115', description: 'Average construction' },
  { ewcCode: '100116', description: 'Average construction' },
  { ewcCode: '100117', description: 'Average construction' },
  { ewcCode: '100118', description: 'Average construction' },
  { ewcCode: '100119', description: 'Average construction' },
  { ewcCode: '100120', description: 'Average construction' },
  { ewcCode: '100121', description: 'Average construction' },
  { ewcCode: '100122', description: 'Average construction' },
  { ewcCode: '100123', description: 'Average construction' },
  { ewcCode: '100124', description: 'Soils' },
  { ewcCode: '100125', description: 'Average construction' },
  { ewcCode: '100126', description: 'Average construction' },
  { ewcCode: '100199', description: 'Average construction' },
  { ewcCode: '100201', description: 'Metals' },
  { ewcCode: '100202', description: 'Metals' },
  { ewcCode: '100207', description: 'Average construction' },
  { ewcCode: '100208', description: 'Average construction' },
  { ewcCode: '100210', description: 'Metals' },
  { ewcCode: '100211', description: 'Average construction' },
  { ewcCode: '100212', description: 'Average construction' },
  { ewcCode: '100213', description: 'Average construction' },
  { ewcCode: '100214', description: 'Average construction' },
  { ewcCode: '100215', description: 'Average construction' },
  { ewcCode: '100299', description: 'Average construction' },
  { ewcCode: '100302', description: 'Average construction' },
  { ewcCode: '100304', description: 'Metals' },
  { ewcCode: '100305', description: 'Metals' },
  { ewcCode: '100308', description: 'Average construction' },
  { ewcCode: '100309', description: 'Average construction' },
  { ewcCode: '100315', description: 'Average construction' },
  { ewcCode: '100316', description: 'Average construction' },
  { ewcCode: '100317', description: 'Average construction' },
  { ewcCode: '100318', description: 'Average construction' },
  { ewcCode: '100319', description: 'Average construction' },
  { ewcCode: '100320', description: 'Average construction' },
  { ewcCode: '100321', description: 'Average construction' },
  { ewcCode: '100322', description: 'Average construction' },
  { ewcCode: '100323', description: 'Average construction' },
  { ewcCode: '100324', description: 'Average construction' },
  { ewcCode: '100325', description: 'Average construction' },
  { ewcCode: '100326', description: 'Average construction' },
  { ewcCode: '100327', description: 'Average construction' },
  { ewcCode: '100328', description: 'Average construction' },
  { ewcCode: '100329', description: 'Average construction' },
  { ewcCode: '100330', description: 'Average construction' },
  { ewcCode: '100399', description: 'Average construction' },
  { ewcCode: '100401', description: 'Metals' },
  { ewcCode: '100402', description: 'Average construction' },
  { ewcCode: '100403', description: 'Average construction' },
  { ewcCode: '100404', description: 'Average construction' },
  { ewcCode: '100405', description: 'Average construction' },
  { ewcCode: '100406', description: 'Average construction' },
  { ewcCode: '100407', description: 'Average construction' },
  { ewcCode: '100409', description: 'Average construction' },
  { ewcCode: '100410', description: 'Average construction' },
  { ewcCode: '100499', description: 'Average construction' },
  { ewcCode: '100501', description: 'Metals' },
  { ewcCode: '100503', description: 'Average construction' },
  { ewcCode: '100504', description: 'Average construction' },
  { ewcCode: '100505', description: 'Average construction' },
  { ewcCode: '100506', description: 'Average construction' },
  { ewcCode: '100508', description: 'Average construction' },
  { ewcCode: '100509', description: 'Average construction' },
  { ewcCode: '100510', description: 'Average construction' },
  { ewcCode: '100511', description: 'Average construction' },
  { ewcCode: '100599', description: 'Average construction' },
  { ewcCode: '100601', description: 'Average construction' },
  { ewcCode: '100602', description: 'Average construction' },
  { ewcCode: '100603', description: 'Average construction' },
  { ewcCode: '100604', description: 'Average construction' },
  { ewcCode: '100606', description: 'Average construction' },
  { ewcCode: '100607', description: 'Average construction' },
  { ewcCode: '100609', description: 'Average construction' },
  { ewcCode: '100610', description: 'Average construction' },
  { ewcCode: '100699', description: 'Average construction' },
  { ewcCode: '100701', description: 'Average construction' },
  { ewcCode: '100702', description: 'Average construction' },
  { ewcCode: '100703', description: 'Average construction' },
  { ewcCode: '100704', description: 'Average construction' },
  { ewcCode: '100705', description: 'Average construction' },
  { ewcCode: '100707', description: 'Average construction' },
  { ewcCode: '100708', description: 'Average construction' },
  { ewcCode: '100799', description: 'Average construction' },
  { ewcCode: '100804', description: 'Average construction' },
  { ewcCode: '100808', description: 'Average construction' },
  { ewcCode: '100809', description: 'Metals' },
  { ewcCode: '100810', description: 'Average construction' },
  { ewcCode: '100811', description: 'Average construction' },
  { ewcCode: '100812', description: 'Average construction' },
  { ewcCode: '100813', description: 'Average construction' },
  { ewcCode: '100814', description: 'Average construction' },
  { ewcCode: '100815', description: 'Average construction' },
  { ewcCode: '100816', description: 'Average construction' },
  { ewcCode: '100817', description: 'Average construction' },
  { ewcCode: '100818', description: 'Average construction' },
  { ewcCode: '100819', description: 'Average construction' },
  { ewcCode: '100820', description: 'Average construction' },
  { ewcCode: '100899', description: 'Average construction' },
  { ewcCode: '100903', description: 'Metals' },
  { ewcCode: '100905', description: 'Average construction' },
  { ewcCode: '100906', description: 'Average construction' },
  { ewcCode: '100907', description: 'Average construction' },
  { ewcCode: '100908', description: 'Average construction' },
  { ewcCode: '100909', description: 'Average construction' },
  { ewcCode: '100910', description: 'Average construction' },
  { ewcCode: '100911', description: 'Average construction' },
  { ewcCode: '100912', description: 'Average construction' },
  { ewcCode: '100913', description: 'Average construction' },
  { ewcCode: '100914', description: 'Average construction' },
  { ewcCode: '100915', description: 'Average construction' },
  { ewcCode: '100916', description: 'Average construction' },
  { ewcCode: '100999', description: 'Average construction' },
  { ewcCode: '101003', description: 'Metals' },
  { ewcCode: '101005', description: 'Average construction' },
  { ewcCode: '101006', description: 'Average construction' },
  { ewcCode: '101007', description: 'Average construction' },
  { ewcCode: '101008', description: 'Average construction' },
  { ewcCode: '101009', description: 'Average construction' },
  { ewcCode: '101010', description: 'Average construction' },
  { ewcCode: '101011', description: 'Average construction' },
  { ewcCode: '101012', description: 'Average construction' },
  { ewcCode: '101013', description: 'Average construction' },
  { ewcCode: '101014', description: 'Average construction' },
  { ewcCode: '101015', description: 'Average construction' },
  { ewcCode: '101016', description: 'Average construction' },
  { ewcCode: '101099', description: 'Average construction' },
  { ewcCode: '101103', description: 'Glass' },
  { ewcCode: '101105', description: 'Average construction' },
  { ewcCode: '101109', description: 'Average construction' },
  { ewcCode: '101110', description: 'Average construction' },
  { ewcCode: '101111', description: 'Metals' },
  { ewcCode: '101112', description: 'Glass' },
  { ewcCode: '101113', description: 'Average construction' },
  { ewcCode: '101114', description: 'Average construction' },
  { ewcCode: '101115', description: 'Average construction' },
  { ewcCode: '101116', description: 'Average construction' },
  { ewcCode: '101117', description: 'Average construction' },
  { ewcCode: '101118', description: 'Average construction' },
  { ewcCode: '101119', description: 'Average construction' },
  { ewcCode: '101120', description: 'Average construction' },
  { ewcCode: '101199', description: 'Average construction' },
  { ewcCode: '101201', description: 'Average construction' },
  { ewcCode: '101203', description: 'Average construction' },
  { ewcCode: '101205', description: 'Average construction' },
  { ewcCode: '101206', description: 'Average construction' },
  { ewcCode: '101208', description: 'Bricks' },
  { ewcCode: '101209', description: 'Average construction' },
  { ewcCode: '101210', description: 'Average construction' },
  { ewcCode: '101211', description: 'Metals' },
  { ewcCode: '101212', description: 'Average construction' },
  { ewcCode: '101213', description: 'Average construction' },
  { ewcCode: '101299', description: 'Average construction' },
  { ewcCode: '101301', description: 'Average construction' },
  { ewcCode: '101304', description: 'Average construction' },
  { ewcCode: '101306', description: 'Average construction' },
  { ewcCode: '101307', description: 'Average construction' },
  { ewcCode: '101309', description: 'Asbestos' },
  { ewcCode: '101310', description: 'Asbestos' },
  { ewcCode: '101311', description: 'Average construction' },
  { ewcCode: '101312', description: 'Average construction' },
  { ewcCode: '101313', description: 'Average construction' },
  { ewcCode: '101314', description: 'Concrete' },
  { ewcCode: '101399', description: 'Average construction' },
  { ewcCode: '101401', description: 'Metals' },
  { ewcCode: '110105', description: 'Average construction' },
  { ewcCode: '110106', description: 'Average construction' },
  { ewcCode: '110107', description: 'Average construction' },
  { ewcCode: '110108', description: 'Average construction' },
  { ewcCode: '110109', description: 'Average construction' },
  { ewcCode: '110110', description: 'Average construction' },
  { ewcCode: '110111', description: 'Average construction' },
  { ewcCode: '110112', description: 'Average construction' },
  { ewcCode: '110113', description: 'Average construction' },
  { ewcCode: '110114', description: 'Average construction' },
  { ewcCode: '110115', description: 'Average construction' },
  { ewcCode: '110116', description: 'Average construction' },
  { ewcCode: '110198', description: 'Average construction' },
  { ewcCode: '110199', description: 'Average construction' },
  { ewcCode: '110202', description: 'Metals' },
  { ewcCode: '110203', description: 'Average construction' },
  { ewcCode: '110205', description: 'Metals' },
  { ewcCode: '110206', description: 'Metals' },
  { ewcCode: '110207', description: 'Average construction' },
  { ewcCode: '110299', description: 'Average construction' },
  { ewcCode: '110301', description: 'Average construction' },
  { ewcCode: '110302', description: 'Average construction' },
  { ewcCode: '110501', description: 'Metals' },
  { ewcCode: '110502', description: 'Average construction' },
  { ewcCode: '110503', description: 'Average construction' },
  { ewcCode: '110504', description: 'Average construction' },
  { ewcCode: '110599', description: 'Average construction' },
  { ewcCode: '120101', description: 'Metals' },
  { ewcCode: '120102', description: 'Metals' },
  { ewcCode: '120103', description: 'Metals' },
  { ewcCode: '120104', description: 'Metals' },
  { ewcCode: '120105', description: 'Plastics: average plastics' },
  { ewcCode: '120106', description: 'Mineral oil' },
  { ewcCode: '120107', description: 'Mineral oil' },
  { ewcCode: '120108', description: 'Average construction' },
  { ewcCode: '120109', description: 'Average construction' },
  { ewcCode: '120110', description: 'Average construction' },
  { ewcCode: '120112', description: 'Average construction' },
  { ewcCode: '120113', description: 'Average construction' },
  { ewcCode: '120114', description: 'Average construction' },
  { ewcCode: '120115', description: 'Average construction' },
  { ewcCode: '120116', description: 'Average construction' },
  { ewcCode: '120117', description: 'Average construction' },
  { ewcCode: '120118', description: 'Metals' },
  { ewcCode: '120119', description: 'Average construction' },
  { ewcCode: '120120', description: 'Average construction' },
  { ewcCode: '120121', description: 'Average construction' },
  { ewcCode: '120199', description: 'Average construction' },
  { ewcCode: '120301', description: 'Average construction' },
  { ewcCode: '120302', description: 'Average construction' },
  { ewcCode: '130101', description: 'Average construction' },
  { ewcCode: '130104', description: 'Average construction' },
  { ewcCode: '130105', description: 'Average construction' },
  { ewcCode: '130109', description: 'Mineral oil' },
  { ewcCode: '130110', description: 'Mineral oil' },
  { ewcCode: '130111', description: 'Average construction' },
  { ewcCode: '130112', description: 'Average construction' },
  { ewcCode: '130113', description: 'Average construction' },
  { ewcCode: '130204', description: 'Mineral oil' },
  { ewcCode: '130205', description: 'Mineral oil' },
  { ewcCode: '130206', description: 'Average construction' },
  { ewcCode: '130207', description: 'Average construction' },
  { ewcCode: '130208', description: 'Average construction' },
  { ewcCode: '130301', description: 'Average construction' },
  { ewcCode: '130306', description: 'Mineral oil' },
  { ewcCode: '130307', description: 'Mineral oil' },
  { ewcCode: '130308', description: 'Average construction' },
  { ewcCode: '130309', description: 'Average construction' },
  { ewcCode: '130310', description: 'Average construction' },
  { ewcCode: '130401', description: 'Average construction' },
  { ewcCode: '130402', description: 'Average construction' },
  { ewcCode: '130403', description: 'Average construction' },
  { ewcCode: '130501', description: 'Average construction' },
  { ewcCode: '130502', description: 'Average construction' },
  { ewcCode: '130503', description: 'Average construction' },
  { ewcCode: '130506', description: 'Average construction' },
  { ewcCode: '130507', description: 'Average construction' },
  { ewcCode: '130508', description: 'Average construction' },
  { ewcCode: '130701', description: 'Average construction' },
  { ewcCode: '130702', description: 'Average construction' },
  { ewcCode: '130703', description: 'Average construction' },
  { ewcCode: '130801', description: 'Average construction' },
  { ewcCode: '130802', description: 'Average construction' },
  { ewcCode: '130899', description: 'Average construction' },
  { ewcCode: '140601', description: 'Average construction' },
  { ewcCode: '140602', description: 'Average construction' },
  { ewcCode: '140603', description: 'Average construction' },
  { ewcCode: '140604', description: 'Average construction' },
  { ewcCode: '140605', description: 'Average construction' },
  { ewcCode: '150101', description: 'Paper and board: mixed' },
  { ewcCode: '150102', description: 'Plastics: average plastics' },
  { ewcCode: '150103', description: 'Wood' },
  { ewcCode: '150104', description: 'Metals' },
  { ewcCode: '150105', description: 'Average construction' },
  { ewcCode: '150106', description: 'Average construction' },
  { ewcCode: '150107', description: 'Glass' },
  { ewcCode: '150109', description: 'Average construction' },
  { ewcCode: '150110', description: 'Average construction' },
  { ewcCode: '150111', description: 'Asbestos' },
  { ewcCode: '150202', description: 'Clothing' },
  { ewcCode: '150203', description: 'Clothing' },
  { ewcCode: '160103', description: 'Tyres' },
  { ewcCode: '160104', description: 'Average construction' },
  { ewcCode: '160106', description: 'Average construction' },
  { ewcCode: '160107', description: 'Average construction' },
  { ewcCode: '160108', description: 'Metals' },
  { ewcCode: '160109', description: 'Average construction' },
  { ewcCode: '160110', description: 'Average construction' },
  { ewcCode: '160111', description: 'Asbestos' },
  { ewcCode: '160112', description: 'Average construction' },
  { ewcCode: '160113', description: 'Average construction' },
  { ewcCode: '160114', description: 'Average construction' },
  { ewcCode: '160115', description: 'Average construction' },
  { ewcCode: '160116', description: 'Average construction' },
  { ewcCode: '160117', description: 'Metals' },
  { ewcCode: '160118', description: 'Metals' },
  { ewcCode: '160119', description: 'Plastics: average plastics' },
  { ewcCode: '160120', description: 'Glass' },
  { ewcCode: '160121', description: 'Average construction' },
  { ewcCode: '160122', description: 'Average construction' },
  { ewcCode: '160199', description: 'Average construction' },
  { ewcCode: '160209', description: 'Average construction' },
  { ewcCode: '160210', description: 'Average construction' },
  { ewcCode: '160211', description: 'Average construction' },
  { ewcCode: '160212', description: 'Asbestos' },
  { ewcCode: '160213', description: 'Average construction' },
  { ewcCode: '160214', description: 'Average construction' },
  { ewcCode: '160215', description: 'Average construction' },
  { ewcCode: '160216', description: 'Average construction' },
  { ewcCode: '160303', description: 'Average construction' },
  { ewcCode: '160304', description: 'Average construction' },
  { ewcCode: '160305', description: 'Average construction' },
  { ewcCode: '160306', description: 'Organic: mixed food and garden waste' },
  { ewcCode: '160401', description: 'Average construction' },
  { ewcCode: '160402', description: 'Average construction' },
  { ewcCode: '160403', description: 'Average construction' },
  { ewcCode: '160504', description: 'Average construction' },
  { ewcCode: '160505', description: 'Average construction' },
  { ewcCode: '160506', description: 'Average construction' },
  { ewcCode: '160507', description: 'Average construction' },
  { ewcCode: '160508', description: 'Average construction' },
  { ewcCode: '160509', description: 'Average construction' },
  { ewcCode: '160601', description: 'Metals' },
  { ewcCode: '160602', description: 'Batteries' },
  { ewcCode: '160603', description: 'Metals' },
  { ewcCode: '160604', description: 'Average construction' },
  { ewcCode: '160605', description: 'Average construction' },
  { ewcCode: '160606', description: 'Average construction' },
  { ewcCode: '160708', description: 'Average construction' },
  { ewcCode: '160709', description: 'Average construction' },
  { ewcCode: '160799', description: 'Average construction' },
  { ewcCode: '160801', description: 'Metals' },
  { ewcCode: '160802', description: 'Metals' },
  { ewcCode: '160803', description: 'Metals' },
  { ewcCode: '160804', description: 'Average construction' },
  { ewcCode: '160805', description: 'Average construction' },
  { ewcCode: '160806', description: 'Average construction' },
  { ewcCode: '160807', description: 'Average construction' },
  { ewcCode: '160901', description: 'Average construction' },
  { ewcCode: '160902', description: 'Average construction' },
  { ewcCode: '160903', description: 'Average construction' },
  { ewcCode: '160904', description: 'Average construction' },
  { ewcCode: '161001', description: 'Average construction' },
  { ewcCode: '161002', description: 'Average construction' },
  { ewcCode: '161003', description: 'Average construction' },
  { ewcCode: '161004', description: 'Average construction' },
  { ewcCode: '161101', description: 'Metals' },
  { ewcCode: '161102', description: 'Metals' },
  { ewcCode: '161103', description: 'Metals' },
  { ewcCode: '161104', description: 'Metals' },
  { ewcCode: '161105', description: 'Average construction' },
  { ewcCode: '161106', description: 'Average construction' },
  { ewcCode: '170101', description: 'Concrete' },
  { ewcCode: '170102', description: 'Bricks' },
  { ewcCode: '170103', description: 'Average construction' },
  { ewcCode: '170106', description: 'Concrete' },
  { ewcCode: '170107', description: 'Concrete' },
  { ewcCode: '170201', description: 'Wood' },
  { ewcCode: '170202', description: 'Glass' },
  { ewcCode: '170203', description: 'Plastics: average plastics' },
  { ewcCode: '170204', description: 'Wood' },
  { ewcCode: '170301', description: 'Average construction' },
  { ewcCode: '170302', description: 'Average construction' },
  { ewcCode: '170303', description: 'Average construction' },
  { ewcCode: '170401', description: 'Metals' },
  { ewcCode: '170402', description: 'Metals' },
  { ewcCode: '170403', description: 'Metals' },
  { ewcCode: '170404', description: 'Metals' },
  { ewcCode: '170405', description: 'Metals' },
  { ewcCode: '170406', description: 'Metals' },
  { ewcCode: '170407', description: 'Metals' },
  { ewcCode: '170409', description: 'Metals' },
  { ewcCode: '170410', description: 'Average construction' },
  { ewcCode: '170411', description: 'Average construction' },
  { ewcCode: '170503', description: 'Soils' },
  { ewcCode: '170504', description: 'Soils' },
  { ewcCode: '170505', description: 'Average construction' },
  { ewcCode: '170506', description: 'Average construction' },
  { ewcCode: '170507', description: 'Aggregates' },
  { ewcCode: '170508', description: 'Aggregates' },
  { ewcCode: '170601', description: 'Asbestos' },
  { ewcCode: '170603', description: 'Insulation' },
  { ewcCode: '170604', description: 'Insulation' },
  { ewcCode: '170605', description: 'Asbestos' },
  { ewcCode: '170801', description: 'Plasterboard' },
  { ewcCode: '170802', description: 'Plasterboard' },
  { ewcCode: '170901', description: 'Metals' },
  { ewcCode: '170902', description: 'Average construction' },
  { ewcCode: '170903', description: 'Average construction' },
  { ewcCode: '170904', description: 'Average construction' },
  { ewcCode: '180101', description: 'Average construction' },
  { ewcCode: '180102', description: 'Average construction' },
  { ewcCode: '180103', description: 'Average construction' },
  { ewcCode: '180104', description: 'Clothing' },
  { ewcCode: '180106', description: 'Average construction' },
  { ewcCode: '180107', description: 'Average construction' },
  { ewcCode: '180108', description: 'Average construction' },
  { ewcCode: '180109', description: 'Average construction' },
  { ewcCode: '180110', description: 'Average construction' },
  { ewcCode: '180201', description: 'Average construction' },
  { ewcCode: '180202', description: 'Average construction' },
  { ewcCode: '180203', description: 'Average construction' },
  { ewcCode: '180205', description: 'Average construction' },
  { ewcCode: '180206', description: 'Average construction' },
  { ewcCode: '180207', description: 'Average construction' },
  { ewcCode: '180208', description: 'Average construction' },
  { ewcCode: '190102', description: 'Average construction' },
  { ewcCode: '190105', description: 'Average construction' },
  { ewcCode: '190106', description: 'Average construction' },
  { ewcCode: '190107', description: 'Average construction' },
  { ewcCode: '190110', description: 'Average construction' },
  { ewcCode: '190111', description: 'Average construction' },
  { ewcCode: '190112', description: 'Average construction' },
  { ewcCode: '190113', description: 'Average construction' },
  { ewcCode: '190114', description: 'Average construction' },
  { ewcCode: '190115', description: 'Average construction' },
  { ewcCode: '190116', description: 'Average construction' },
  { ewcCode: '190117', description: 'Average construction' },
  { ewcCode: '190118', description: 'Average construction' },
  { ewcCode: '190119', description: 'Soils' },
  { ewcCode: '190199', description: 'Average construction' },
  { ewcCode: '190203', description: 'Average construction' },
  { ewcCode: '190204', description: 'Average construction' },
  { ewcCode: '190205', description: 'Average construction' },
  { ewcCode: '190206', description: 'Average construction' },
  { ewcCode: '190207', description: 'Average construction' },
  { ewcCode: '190208', description: 'Average construction' },
  { ewcCode: '190209', description: 'Average construction' },
  { ewcCode: '190210', description: 'Average construction' },
  { ewcCode: '190211', description: 'Average construction' },
  { ewcCode: '190299', description: 'Average construction' },
  { ewcCode: '190304', description: 'Average construction' },
  { ewcCode: '190305', description: 'Average construction' },
  { ewcCode: '190306', description: 'Average construction' },
  { ewcCode: '190307', description: 'Average construction' },
  { ewcCode: '190401', description: 'Average construction' },
  { ewcCode: '190402', description: 'Average construction' },
  { ewcCode: '190403', description: 'Average construction' },
  { ewcCode: '190404', description: 'Average construction' },
  { ewcCode: '190501', description: 'Average construction' },
  { ewcCode: '190502', description: 'Organic: food and drink waste' },
  { ewcCode: '190503', description: 'Organic: mixed food and garden waste' },
  { ewcCode: '190599', description: 'Average construction' },
  { ewcCode: '190603', description: 'Average construction' },
  { ewcCode: '190604', description: 'Average construction' },
  { ewcCode: '190605', description: 'Average construction' },
  { ewcCode: '190606', description: 'Average construction' },
  { ewcCode: '190699', description: 'Average construction' },
  { ewcCode: '190702', description: 'Average construction' },
  { ewcCode: '190703', description: 'Average construction' },
  { ewcCode: '190801', description: 'Average construction' },
  { ewcCode: '190802', description: 'Average construction' },
  { ewcCode: '190805', description: 'Average construction' },
  { ewcCode: '190806', description: 'Average construction' },
  { ewcCode: '190807', description: 'Average construction' },
  { ewcCode: '190808', description: 'Metals' },
  { ewcCode: '190809', description: 'Average construction' },
  { ewcCode: '190810', description: 'Average construction' },
  { ewcCode: '190811', description: 'Commercial and industrial waste' },
  { ewcCode: '190812', description: 'Commercial and industrial waste' },
  { ewcCode: '190813', description: 'Commercial and industrial waste' },
  { ewcCode: '190814', description: 'Commercial and industrial waste' },
  { ewcCode: '190899', description: 'Average construction' },
  { ewcCode: '190901', description: 'Average construction' },
  { ewcCode: '190902', description: 'Average construction' },
  { ewcCode: '190903', description: 'Average construction' },
  { ewcCode: '190904', description: 'Average construction' },
  { ewcCode: '190905', description: 'Average construction' },
  { ewcCode: '190906', description: 'Average construction' },
  { ewcCode: '190999', description: 'Average construction' },
  { ewcCode: '191001', description: 'Metals' },
  { ewcCode: '191002', description: 'Metals' },
  { ewcCode: '191003', description: 'Average construction' },
  { ewcCode: '191004', description: 'Average construction' },
  { ewcCode: '191005', description: 'Average construction' },
  { ewcCode: '191006', description: 'Average construction' },
  { ewcCode: '191101', description: 'Soils' },
  { ewcCode: '191102', description: 'Average construction' },
  { ewcCode: '191103', description: 'Average construction' },
  { ewcCode: '191104', description: 'Average construction' },
  { ewcCode: '191105', description: 'Average construction' },
  { ewcCode: '191106', description: 'Average construction' },
  { ewcCode: '191107', description: 'Average construction' },
  { ewcCode: '191199', description: 'Average construction' },
  { ewcCode: '191201', description: 'Paper and board: mixed' },
  { ewcCode: '191202', description: 'Metals' },
  { ewcCode: '191203', description: 'Metals' },
  { ewcCode: '191204', description: 'Plastics: average plastics' },
  { ewcCode: '191205', description: 'Glass' },
  { ewcCode: '191206', description: 'Wood' },
  { ewcCode: '191207', description: 'Wood' },
  { ewcCode: '191208', description: 'Clothing' },
  { ewcCode: '191209', description: 'Aggregates' },
  { ewcCode: '191210', description: 'Average construction' },
  { ewcCode: '191211', description: 'Average construction' },
  { ewcCode: '191212', description: 'Average construction' },
  { ewcCode: '191301', description: 'Soils' },
  { ewcCode: '191302', description: 'Soils' },
  { ewcCode: '191303', description: 'Soils' },
  { ewcCode: '191304', description: 'Soils' },
  { ewcCode: '191305', description: 'Average construction' },
  { ewcCode: '191306', description: 'Average construction' },
  { ewcCode: '191307', description: 'Average construction' },
  { ewcCode: '191308', description: 'Average construction' },
  { ewcCode: '200101', description: 'Paper and board: mixed' },
  { ewcCode: '200102', description: 'Glass' },
  { ewcCode: '200108', description: 'Organic: food and drink waste' },
  { ewcCode: '200110', description: 'Clothing' },
  { ewcCode: '200111', description: 'Clothing' },
  { ewcCode: '200113', description: 'Average construction' },
  { ewcCode: '200114', description: 'Average construction' },
  { ewcCode: '200115', description: 'Average construction' },
  { ewcCode: '200117', description: 'Average construction' },
  { ewcCode: '200119', description: 'Average construction' },
  { ewcCode: '200121', description: 'Average construction' },
  { ewcCode: '200123', description: 'Average construction' },
  { ewcCode: '200125', description: 'Organic: food and drink waste' },
  { ewcCode: '200126', description: 'Average construction' },
  { ewcCode: '200127', description: 'Average construction' },
  { ewcCode: '200128', description: 'Average construction' },
  { ewcCode: '200129', description: 'Average construction' },
  { ewcCode: '200130', description: 'Average construction' },
  { ewcCode: '200131', description: 'Average construction' },
  { ewcCode: '200132', description: 'Average construction' },
  { ewcCode: '200133', description: 'Batteries' },
  { ewcCode: '200134', description: 'Batteries' },
  { ewcCode: '200135', description: 'WEEE - mixed' },
  { ewcCode: '200136', description: 'WEEE - mixed' },
  { ewcCode: '200137', description: 'Wood' },
  { ewcCode: '200138', description: 'Wood' },
  { ewcCode: '200139', description: 'Plastics: average plastics' },
  { ewcCode: '200140', description: 'Metals' },
  { ewcCode: '200141', description: 'Average construction' },
  { ewcCode: '200199', description: 'Average construction' },
  { ewcCode: '200201', description: 'Average construction' },
  { ewcCode: '200202', description: 'Soils' },
  { ewcCode: '200203', description: 'Average construction' },
  { ewcCode: '200301', description: 'Average construction' },
  { ewcCode: '200302', description: 'Average construction' },
  { ewcCode: '200303', description: 'Average construction' },
  { ewcCode: '200304', description: 'Average construction' },
  { ewcCode: '200306', description: 'Average construction' },
  { ewcCode: '200307', description: 'Average construction' },
  { ewcCode: '200399', description: 'Average construction' }
]
